import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {HistoricComponent} from './historic.component';
import {MatTableModule} from '@angular/material/table';
import {MatSortModule} from '@angular/material/sort';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MessagesModule} from '@components/messages/messages.module';

export const HistoricRoutes: Routes = [
    {path: '', component: HistoricComponent},
];

@NgModule({
    declarations: [
        HistoricComponent
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(HistoricRoutes),
        MatTableModule,
        MatSortModule,
        MatProgressSpinnerModule,
        MessagesModule,
    ]
})
export class HistoricModule {
}
